import React from "react";
import { cn } from "../../lib/utils";
import styles from "./static-infobanner.module.css";

export default function StaticInfoBanner({ text }) {
  if (text)
    return (
      <div className="relative">
        <h2 className={cn(styles.infobanner, "!bg-primary !text-fontPrimary")}>{text}</h2>
      </div>
    );
  return null;
}
